// extracted by mini-css-extract-plugin
export default {"ratingWrapper":"RatingStars_ratingWrapper__hMBLB","star":"RatingStars_star__aV-H5"};